<div class="dashboard-wrapper">
  <div class="">
    <div id="home-view-button" class="category-wrapper" (click)="switchToHomeView()">
      <div class="flex-row">
        <div class="flex-1">
          <span class="category-title"> Home </span>
        </div>
      </div>
    </div>
    <div class="category-wrapper">
      <div class="flex-row">
        <div class="flex-2" (click)="toggleOrdersInProgress()">
          <span class="category-title"> Orders In-Progress </span>
          <img alt="" src="../../assets/arrow-icon.svg" [ngClass]="{'show-orders': showOrdersInProgress}">
        </div>
      </div>
    </div>
    @if (showOrdersInProgress) {
      <div class="item-wrapper">
        @if (ordersInProgress && !(ordersInProgress.length) ) {
          <div class="category-item">
            <span>No orders to show </span>
          </div>
        }
        @for (order of ordersInProgress; track order) {
          <div class="category-item" (click)="selectOrder(order)" [ngClass]="{'item-selected': order === selectedOrder()}">
            <div class="flex-row">
              <div class="flex-1">
                <span class="item-idle-in-progress" [ngClass]="{'item-selected-date': order === selectedOrder()}"> {{order.startedDate.toLocaleDateString()}}</span>
              </div>
              <div class="flex-5 order-title">
                {{ order.name}}
                <img alt="" src="../../assets/unsaved.png" [ngStyle]="{'display':  order.unsaved ? 'inline-block' : 'none'}">
              </div>
            </div>
          </div>
        }
      </div>
    }
    <div class="category-wrapper">
      <div class="flex-row">
        <div class="flex-2" (click)="toggleSubmittedOrders()">
          <span class="category-title"> Submitted Orders </span>
          <img alt="" src="../../assets/arrow-icon.svg" [ngClass]="{'show-orders': showSubmittedOrders}">
        </div>
      </div>
    </div>
    @if (showSubmittedOrders) {
      <div class="item-wrapper">
        @if (submittedOrders && !(submittedOrders.length) ) {
          <div class="category-item">
            <span>No orders to show</span>
          </div>
        }
        @for (order of submittedOrders; track order) {
          <div class="category-item" (click)="selectOrder(order)" [ngClass]="{'item-selected': order === selectedOrder()}">
            <div class="flex-row">
              <div class="flex-1">
                <span class="item-idle" [ngClass]="{'item-selected-date': order === selectedOrder()}"> {{order.submissionDate.toLocaleDateString()}} </span>
              </div>
              <div class="flex-4 order-title">
                {{ order.name }}
              </div>
            </div>
          </div>
        }
      </div>
    }
    <div id="training-link-button" class="category-wrapper">
      <div class="flex-row">
        <div class="flex-1">
          <span class="category-title"><a href="https://rise.articulate.com/share/wa1108TZ8MZEAv6UiX_VlKFypTCBRcLe" target="_blank">Training</a></span>
        </div>
      </div>
    </div>
    <div id="account-view-button" class="category-wrapper" (click)="switchToAccountView()">
      <div class="flex-row">
        <div class="flex-1">
          <span class="category-title"> Account </span>
        </div>
      </div>
    </div>


    <!-- <button (click)="testing()">Testing</button> <br/> -->
  </div>
</div>
